import requestStatuses from '@cinch/oxd-utils/request-status/src'

import * as types from '../types'

export interface PartnersReducer {
  customers: Cinch.Customer[]
  dataQuery?: {
    startDate: string
    endDate: string
    customerNoList: string
  }
  downloadEvents: {
    fetchStatus: string
    error: string
    data: object[]
  }
  partnersSummaryData: {
    SearchAppearances: number | null
    AdvertViews: number | null
    FavouritedVehicles: number | null
  }
  partnersCustomerInteractionsData: {
    LocationViews: number | null
    TelephoneCalls: number | null
    Emails: number | null
    WebsiteReferrals: number | null
    CallbackRequests: number | null
  }
}

export const initialState: PartnersReducer = {
  customers: [],
  dataQuery: {
    startDate: '',
    endDate: '',
    customerNoList: '',
  },
  downloadEvents: {
    fetchStatus: requestStatuses.INITIAL,
    error: '',
    data: [],
  },
  partnersSummaryData: {
    SearchAppearances: null,
    AdvertViews: null,
    FavouritedVehicles: null,
  },
  partnersCustomerInteractionsData: {
    LocationViews: null,
    TelephoneCalls: null,
    Emails: null,
    WebsiteReferrals: null,
    CallbackRequests: null,
  },
}

export default (state = initialState, { payload, type }: any): PartnersReducer => {
  switch (type) {
    case types.PARTNERS_DATA_LOAD_REQUEST:
      return {
        ...state,
        dataQuery: payload,
      }
    case types.PARTNERS_DATA_LOAD_SUCCESS:
      return {
        ...state,
        partnersSummaryData: payload.partnersSummaryData,
        partnersCustomerInteractionsData: payload.partnersCustomerInteractionsData,
      }
    case types.PARTNERS_PROFILE_LOAD_SUCCESS:
      return {
        ...state,
        customers: payload,
      }
    case types.PARTNERS_DOWNLOAD_REPORT_EVENTS_RESET:
      return {
        ...state,
        downloadEvents: { ...initialState.downloadEvents },
      }
    case types.PARTNERS_DOWNLOAD_REPORT_EVENTS_REQUEST:
      return {
        ...state,
        downloadEvents: {
          ...state.downloadEvents,
          fetchStatus: requestStatuses.PENDING,
          error: '',
          data: [],
        },
      }
    case types.PARTNERS_DOWNLOAD_REPORT_EVENTS_SUCCESS:
      return {
        ...state,
        downloadEvents: {
          ...state.downloadEvents,
          fetchStatus: requestStatuses.SUCCESS,
          data: payload.eventReports,
        },
      }
    case types.PARTNERS_DOWNLOAD_REPORT_EVENTS_FAILURE:
      return {
        ...state,
        downloadEvents: {
          ...state.downloadEvents,
          fetchStatus: requestStatuses.ERROR,
          error: payload.message,
          data: [],
        },
      }
    default:
      return {
        ...state,
      }
  }
}
